<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-lg rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">{{ title }}</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Form -->
    <form [formGroup]="orderForm" (ngSubmit)="submit()" class="p-6">
      <div class="space-y-5">
        <!-- Internal Order ID -->
        <div class="form-group">
          <label for="internalOrderId" class="form-label">Auftrags-Nr. *</label>
          <input
            type="text"
            id="internalOrderId"
            formControlName="internalOrderId"
            class="form-input"
            [class.error]="isFieldInvalid('internalOrderId')"
            placeholder="z.B. A-2024-001"
          />
          @if (isFieldInvalid('internalOrderId')) {
            <span class="form-error">{{ getFieldError('internalOrderId') }}</span>
          }
        </div>

        <!-- Company Name -->
        <div class="form-group">
          <label for="companyName" class="form-label">Kunde *</label>
          <input
            type="text"
            id="companyName"
            formControlName="companyName"
            class="form-input"
            [class.error]="isFieldInvalid('companyName')"
            placeholder="Firmenname"
          />
          @if (isFieldInvalid('companyName')) {
            <span class="form-error">{{ getFieldError('companyName') }}</span>
          }
        </div>

        <div class="form-group">
          <label for="mandantId" class="form-label">Mandat-ID *</label>
          <input
            type="text"
            id="mandantId"
            formControlName="mandantId"
            class="form-input"
            [class.error]="isFieldInvalid('mandantId')"
            placeholder="Mandat-ID"
          />
          @if (isFieldInvalid('mandantId')) {
            <span class="form-error">{{ getFieldError('mandantId') }}</span>
          }
        </div>

        <div class="form-group">
          <label for="customerNr" class="form-label">Kunden-Nr. *</label>
          <input
            type="text"
            id="customerNr"
            formControlName="customerNr"
            class="form-input"
            [class.error]="isFieldInvalid('customerNr')"
            placeholder="Kundennummer"
          />
          @if (isFieldInvalid('customerNr')) {
            <span class="form-error">{{ getFieldError('customerNr') }}</span>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 mt-8 pt-6 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
        <button type="submit" class="btn-primary px-5 py-2.5 text-sm" [disabled]="isSubmitting">
          @if (isSubmitting) {
            <span class="flex items-center gap-2">
              <span class="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></span>
              Speichern...
            </span>
          } @else {
            {{ isEditMode ? 'Speichern' : 'Hinzufügen' }}
          }
        </button>
      </div>
    </form>
  </div>
</div>
